export default Object.freeze({
  None: 0,
  AutomyInternal: 1,
  Operator: 2,
  Distributor: 3,
  Partner: 4,
  Reseller: 5,
  Customer: 6,
  ReferralAgent: 7,
});
